export function transformToBackendConsolidateByEventIds(data: any) { // eslint-disable-line
  return {
    events: data.events
  };
}

export function transformFromBackendConsolidateByEventIds(backendType: any) { // eslint-disable-line
  return backendType;
}

